import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import css_248z$1 from '../pim-subnav/styles/pim-subnav.scss.js';
import css_248z from './product-guide.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class ProductGuide extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.selectLabel = 'Stoma size';
        this.firstUpdated = () => {
            const select = document.getElementById('product-guide-select');
            if (select != null) {
                const val = select === null || select === void 0 ? void 0 : select.value;
                const table = document.querySelector(`[data-product-table="${val}"]`);
                table.style.display = 'block';
            }
        };
        this.handleOnChange = (e) => {
            const evt = e.target;
            const table = document.querySelector(`[data-product-table="${evt === null || evt === void 0 ? void 0 : evt.value}"]`);
            const tables = document.querySelectorAll('[data-product-table]');
            tables.forEach(elem => {
                const el = elem;
                el.style.display = 'none';
            });
            if (table != null) {
                table.style.display = 'block';
            }
        };
    }
    render() {
        var _a;
        return $ `<div class="product-guide ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}"><div class="product-guide__select"><label for="product-guide-select">${this.selectLabel}</label><div class="product-guide__select-wrap"><slot name="select" @change="${(e) => this.handleOnChange(e)}"></slot><svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="product-guide__select-arrow"><path d="M9 7.00012L8.39999 7.80012C8.75555 8.06679 9.24445 8.06679 9.60001 7.80012L9 7.00012ZM17.6 1.79999C18.0418 1.46862 18.1314 0.841817 17.8 0.399992C17.4686 -0.0418323 16.8418 -0.131369 16.4 0.200006L17.6 1.79999ZM1.60001 0.200006C1.15818 -0.131369 0.531381 -0.0418323 0.200006 0.399992C-0.131369 0.841817 -0.0418323 1.46862 0.399992 1.79999L1.60001 0.200006ZM9.60001 7.80012L17.6 1.79999L16.4 0.200006L8.39999 6.20013L9.60001 7.80012ZM9.60001 6.20013L1.60001 0.200006L0.399992 1.79999L8.39999 7.80012L9.60001 6.20013Z" fill="#1D1B1F"/></svg></div></div><slot name="product-guide-table"></slot></div>`;
    }
}
ProductGuide.styles = [LitElementWithUtils.styles || [], css_248z, css_248z$1];
__decorate([
    e({ type: String })
], ProductGuide.prototype, "selectLabel", void 0);
customElements.define('product-guide', ProductGuide);

export { ProductGuide };
